<template>
  <div class="view-sale">
    <div class="container">
      <div class="row">
        <div class="col-lg-6 mx-auto text-center py-5">
          <h1 class="font-weight-bold mb-3 text-danger">Ops!</h1>
          <p class="lead text-secondary mb-5">
            Por algum motivo seu acesso está bloqueado.
          </p>
          <p class="lead text-secondary">
            <span class="badge badge-danger">2</span>
            Procure o suporte do seu curso para mais informações.
          </p>
          <p class="lead text-secondary">
            <span class="badge badge-danger">2</span>
            Caso o problema não seja solucionado, envie um e-mail para
            <a :href="`mailto:${email}`">{{ email }}</a>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import get from "lodash/get";

export default {
  computed: {
    email() {
      return get(
        this.$setup,
        "setup.metadata_support.email",
        "suporte@velora.com.br"
      );
    }
  }
};
</script>
